import { useMutation } from '@tanstack/react-query';
import { scaffoldApi } from '../api/scaffoldApi';
import type { ApiError } from '../../common-showcase/types/showcase';
import type { ScaffoldRequest, ScaffoldPreviewResponse } from '../types/scaffold';

/** Mutation: POST /api/eraf/scaffold/previews (queue #642) */
export function useScaffoldPreview() {
  return useMutation<ScaffoldPreviewResponse, ApiError, ScaffoldRequest>({
    mutationFn: (req) => scaffoldApi.previews(req),
    mutationKey: ['project-scaffold', 'preview'],
  });
}
